/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'people.menu.renotify.flag.description': 'Мы отправляем напоминание всем участникам. Это займет не больше минуты.',
  'people.menu.renotify.flag.description.confluence': 'Напомнить участникам команды',
  'people.menu.renotify.flag.title': 'Отправка напоминаний',
  'people.menu.renotify.flag.title.confluence': 'Повторная отправка электронного письма с приглашением',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} пользователь не принял приглашение в {product}. Посмотрите, кто отсутствует, и отправьте напоминание.} few {{userCount,number} пользователя не приняли приглашение в {product}. Посмотрите, кто отсутствует, и отправьте напоминание.} many {{userCount,number} пользователей не приняли приглашение в {product}. Посмотрите, кто отсутствует, и отправьте напоминание.} other {{userCount,number} пользователя не приняли приглашение в {product}. Посмотрите, кто отсутствует, и отправьте напоминание.}}',
  'people.menu.renotify.menu.description.confluence':
    'Некоторые пользователи не приняли приглашение в Confluence. Посмотрите, кто отсутствует, и отправьте напоминание.',
  'people.menu.renotify.menu.dismiss': 'Закрыть',
  'people.menu.renotify.menu.dismiss.confluence': 'Не сейчас',
  'people.menu.renotify.menu.remind': 'Напомнить участникам команды',
  'people.menu.renotify.menu.remind.confluence': 'Напомнить участникам команды',
  'people.menu.renotify.menu.title': 'Все ли в сборе?',
  'people.menu.renotify.modal.copied': 'Ссылка скопирована',
  'people.menu.renotify.modal.copy': 'Копировать ссылку с приглашением',
  'people.menu.renotify.modal.description':
    'Мы можем отправить отсутствующим участникам напоминание по электронной почте, или вы можете сами поделиться ссылкой с приглашением.',
  'people.menu.renotify.modal.description.confluence':
    'Отправьте электронное письмо с приглашением еще раз или скопируйте ссылку на приглашение и поделитесь ею.',
  'people.menu.renotify.modal.dismiss': 'Отмена',
  'people.menu.renotify.modal.resend': 'Отправить напоминание',
  'people.menu.renotify.modal.resend.confluence': 'Отправить повторное приглашение',
  'people.menu.renotify.modal.title': 'Напоминание отсутствующим участникам',
  'people.menu.renotify.modal.title.confluence': 'Напоминание отсутствующим коллегам',
  'ptc.pm.collaborators.title': 'Ваши коллеги',
  'ptc.pm.error-heading': 'Возникла ошибка',
  'ptc.pm.error-image-alt-text': 'Сломанный робот и множество людей, занятых его починкой.',
  'ptc.pm.error-text': 'Мы стараемся отслеживать ошибки, но если обновление не решает проблему, сообщите нам об этом',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} участник} few {{memberCount,number} участника} many {{memberCount,number} участников} other {{memberCount,number} участника}}',
  'ptc.pm.people': 'Пользователи',
  'ptc.pm.teams': 'Команды',
  'ptc.pm.view-your-profile': 'Просмотреть профиль',
  'ptc.pm.your-teams.title': 'Ваши команды',
};
